export default __webpack_public_path__ + "static/media/banner3.776cb3f3.jpeg";